import type { ComponentType } from 'react';

import { Label, LABEL_TYPE } from '@/components/generic';

type RegisterDescriptionItemProps = {
  Icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
};

export const RegisterDescriptionItem = ({
  Icon,
  title,
  description
}: RegisterDescriptionItemProps) => {
  return (
    <div className='flex w-full flex-row gap-x-3'>
      <div className='m-auto flex items-center justify-center rounded-xl border border-[#ebe6ca] bg-white p-3'>
        <Icon className='size-4 !text-primary-blue lg:size-6' />
      </div>
      <div className='flex w-full flex-col justify-center'>
        <Label text={title} type={LABEL_TYPE.H3} className='!font-normal !text-primary-black' />
        <Label text={description} type={LABEL_TYPE.PARAGRAPH2} className='!text-slate-gray' />
      </div>
    </div>
  );
};
